import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import * as api from "../../../api/api";
import Loading from "../../common/Loading";
import Select from "react-select";

const UserRegister = ({ onRegister, onClose }) => {
    const { user } = useSelector((state) => state.account);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        companyCode: user.companyCode,
        companyType: "0000",
        userId: "",
        userType: "6000",
        password: "",
        confirmPassword: "",
        userName: "",
        nickName: "",
        mobileNo: "",
        bankName: "기업은행",
        bankAccount: "",
        bankOwner: "",
        exchangePass: "",
        filler1: "",
        moneyRetYn: "1",
        pointRetYn: "1",
        loginYn: "1",
        bettingYn: "1",
        transferPointYn: "1",
        recommendYn: "1",
        blackYn: "0",
        status: "1",
        useYn: "1",
        userLevel: "1",
        recommendCode: user.userId
    });
    const [isUserIdCheck, setIsUserIdCheck] = useState(false)
    const [bankList, setBankList] = useState([])
    const [partnerList, setPartnerList] = useState([])
    const [selectedPartnerId, setSelectedPartnerId] = useState('');

    const partnerOptions = partnerList.map(partner => ({
        value: partner.userId,
        label: partner.userType === '1000' || partner.userType === '1100' ? "본사" : `${partner.nickName} (${partner.userId})`
    }));

    const checkUserId = () => {
        if (formData.userId.length === 0) {
            window.alert("ID를 입력해주세요.")
            return
        }

        const params = {
            companyCode: user.companyCode,
            userId: formData.userId
        };

        api.userCheck(params).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                if (!data) {
                    window.alert("사용할 수 있는 ID 입니다.")
                    setIsUserIdCheck(true)
                }
                else {
                    window.alert("이미 사용중인 ID 입니다.")
                    setIsUserIdCheck(false)
                }
            }
            else {
                window.alert(statusText)
            }
        })
            .catch(ex => {
                window.alert(ex.message)
            })
    }

    const checkNickname = () => {
        if (formData.nickName.length === 0) {
            window.alert("닉네임을 입력해주세요.")
            return
        }

        const params = {
            companyCode: user.companyCode,
            nickName: formData.nickName
        };

        api.checkNickname(params).then(result => {
            const {data, status, statusText} = result
            if (status === 200) {
                if (!data) {
                    window.alert("사용할 수 있는 닉네임 입니다.")
                    setIsUserIdCheck(true)
                }
                else {
                    window.alert("이미 사용중인 닉네임 입니다.")
                    setIsUserIdCheck(false)
                }
            }
            else {
                window.alert(statusText)
            }
        })
            .catch(ex => {
                window.alert(ex.message)
            })
    }

    const handlePartnerChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : user.userId
        setFormData(prev => ({
            ...prev,
            recommendCode: value
        }));
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            borderColor: '#D1D5DB',
            '&:hover': {
                borderColor: '#6B7280'
            }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#EFF6FF' : 'white',
            color: '#1F2937',
            '&:hover': {
                backgroundColor: '#DBEAFE'
            }
        })
    };

    useEffect(() => {
        fetchPartnerList()
        getBankList()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const fetchPartnerList = () => {
        try {
            const param = {
                companyCode: user.companyCode,
                userId: user.userId
            }

            setLoading(true);
            api.getPartnerPossibleUserList(param).then(result => {
                const {data, status, statusText} = result
                if (status === 200) {
                    setPartnerList(data);
                }
            })
        } catch (error) {
            console.error('파트너 목록 조회 실패:', error);
            window.alert('파트너 목록을 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    }

    const getBankList = () => {
        try {
            const param = {
                companyCode: user.companyCode
            }

            api.getBankList(param).then(result => {
                const {data, status, statusText} = result
                if (status === 200) {
                    setBankList(data);
                    // 은행 목록이 있고 첫 번째 항목이 존재할 때만 설정
                    if (data && data.length > 0) {
                        setFormData((state) => ({
                            ...state, bankName: data[0].bankName
                        }))
                    }
                }
            })
        } catch (error) {
            console.error('은행 목록 조회 실패:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = () => {
        // 유효성 검사
        if (!formData.userId) {
            alert("아이디를 입력해주세요.");
            return;
        }
        if (!formData.password) {
            alert("비밀번호를 입력해주세요.");
            return;
        }

        // 회원가입 데이터 준비
        const registerData = {
            ...formData,
            companyCode: user.companyCode,
            userName: formData.userName,
            userType: formData.recommendCode === user.userId ? "2000" : "6000",
            procUserId: user.userId
        };

        onRegister(registerData);
    };

    return (
        <div className="bg-white rounded-lg">
            {loading && <Loading />}
            <h2 className="text-lg font-bold">회원정보</h2>
            <div className="grid grid-cols-4 gap-2">
                {/* 아이디 */}
                <div className="bg-gray-100 p-2 text-sm">아이디</div>
                <div className="flex flex-row col-span-3 gap-2">
                    <input
                        type="text"
                        name="userId"
                        value={formData.userId}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                    <button className={"rounded bg-zinc-800 text-white text-sm font-bold px-2"}
                            onClick={checkUserId}>중복확인</button>
                </div>

                {/* 비밀번호 */}
                <div className="bg-gray-100 p-2 text-sm">비밀번호</div>
                <div className="col-span-3">
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                </div>

                {/* 이름 */}
                <div className="bg-gray-100 p-2 text-sm">이름</div>
                <div className="col-span-3">
                    <input
                        type="text"
                        name="userName"
                        value={formData.userName}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                </div>

                {/* 닉네임 */}
                <div className="bg-gray-100 p-2 text-sm">닉네임</div>
                <div className="flex flex-row col-span-3 gap-2">
                    <input
                        type="text"
                        name="nickName"
                        value={formData.nickName}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                    <button className={"rounded bg-zinc-800 text-white text-sm font-bold px-2"}
                            onClick={checkNickname}>중복확인</button>
                </div>

                {/* 휴대폰 */}
                <div className="bg-gray-100 p-2 text-sm">휴대폰</div>
                <div className="col-span-3">
                    <input
                        type="text"
                        name="mobileNo"
                        value={formData.mobileNo}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                </div>

                {/* 출금계좌 */}
                <div className="bg-gray-100 p-2 text-sm">환전계좌</div>
                <div className="col-span-3 flex gap-2">
                    <select
                        name="bankName"
                        value={formData.bankName}
                        onChange={handleChange}
                        className="border p-1 text-sm"
                    >
                        {bankList.map((bank) => (
                            <option key={bank.bankCode} value={bank.bankName}>{bank.bankName}</option>
                        ))}
                    </select>
                    <input
                        type="text"
                        name="bankAccount"
                        value={formData.bankAccount}
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="border p-1 w-40 text-sm"
                    />
                    <input
                        type="text"
                        name="bankOwner"
                        value={formData.bankOwner}
                        onChange={handleChange}
                        placeholder="예금주"
                        className="border p-1 w-32 text-sm"
                    />
                </div>

                {/* 출금비밀번호 */}
                <div className="bg-gray-100 p-2 text-sm">환전비밀번호</div>
                <div className="col-span-3">
                    <input
                        type="text"
                        name="exchangePass"
                        value={formData.exchangePass}
                        onChange={handleChange}
                        className="border p-1 w-48 text-sm"
                    />
                </div>

                {/* 회원 상태 */}
                <div className="bg-gray-100 p-2 text-sm">회원 상태</div>
                <div className="col-span-3">
                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="border p-1 text-sm"
                    >
                        <option value={"1"}>정상</option>
                        <option value={"0"}>정지</option>
                        {/*<option value={"0"}>탈퇴</option>*/}
                        <option value={"9"}>요청</option>
                        {/*<option value={"8"}>테스트</option>*/}
                    </select>
                </div>

                {/* 회원 등급 */}
                <div className="bg-gray-100 p-2 text-sm">회원 등급</div>
                <div className="col-span-3">
                    <select
                        name="memberGrade"
                        value={formData.userLevel}
                        onChange={handleChange}
                        className="border p-1 text-sm"
                    >
                        <option value={"1"}>1레벨</option>
                        <option value={"2"}>2레벨</option>
                        <option value={"3"}>3레벨</option>
                        <option value={"4"}>4레벨</option>
                        <option value={"5"}>5레벨</option>
                        <option value={"6"}>6레벨</option>
                        <option value={"7"}>7레벨</option>
                        <option value={"8"}>8레벨</option>
                        <option value={"9"}>9레벨</option>
                        <option value={"10"}>10레벨</option>
                    </select>
                </div>

                {/* 추천코드 */}
                <div className="bg-gray-100 p-2 text-sm">파트너</div>
                <div className="col-span-3">
                    <Select
                        value={partnerOptions.find(option => option.value === formData.recommendCode)}
                        onChange={handlePartnerChange}
                        options={partnerOptions}
                        styles={customStyles}
                        isClearable
                        isSearchable
                        placeholder="파트너 선택"
                        noOptionsMessage={() => "검색 결과가 없습니다"}
                    />
                </div>

                {/* 메모 */}
                <div className="bg-gray-100 p-2 text-sm">메모</div>
                <div className="col-span-3">
                    <textarea
                        name="filler1"
                        value={formData.filler1}
                        onChange={handleChange}
                        className="border p-1 w-full h-32 resize-none text-sm"
                    />
                </div>
            </div>

            <div className="flex justify-center mt-4 gap-2">
                <button
                    onClick={handleSubmit}
                    className="bg-green-800 text-white font-bold w-24 py-1 rounded"
                >
                    회원 추가
                </button>
                <button
                    onClick={onClose}
                    className="bg-gray-800 text-white font-bold w-24 py-1 rounded"
                >
                    닫기
                </button>
            </div>
        </div>
    );
};

export default UserRegister;